import { connect } from "react-redux";

import { actions as modalSignupActions } from "../modal-signup";

import SignupFooter from "./SignupFooter.view";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  handleSignupFooterSubmit: email =>
    dispatch(modalSignupActions.handleSignupFooterSubmit(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupFooter);
